import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'stg-modal-question',
  templateUrl: './modal-question.component.html',
  styleUrls: ['./modal-question.component.scss']
})
export class ModalQuestionComponent implements OnInit {

 

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/shared-components/modal-question/modal-question.component.ts